import { ModuleResourceTypeEnum } from "../../../../Enums/ModuleResourceTypeEnum";

export enum ModuleColEnum {
  Scenario = ModuleResourceTypeEnum.Scenario,
  Task = ModuleResourceTypeEnum.Task,
  Presentation = ModuleResourceTypeEnum.Presentation,
  Video = ModuleResourceTypeEnum.Video,
  MiniGame = ModuleResourceTypeEnum.MiniGame,
  MaterialForStudent = ModuleResourceTypeEnum.MaterialForStudent,
  Name = 6,
}

export const AllModuleCol: ModuleColEnum[] = [
  ModuleColEnum.Name,
  ModuleColEnum.Presentation,
  ModuleColEnum.Video,
  ModuleColEnum.MaterialForStudent,
  ModuleColEnum.Scenario,
  ModuleColEnum.MiniGame,
  ModuleColEnum.Task,
];
